<template>
  <div
    class="tm-calendar-grid"
    :class="{
      'tm-calendar-grid--full-height': fullHeight,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    fullHeight: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
$calendar-border: 1px solid $gray2;

.tm-calendar-grid {
  display: flex;
  flex-direction: column;
  border: $calendar-border;
  border-radius: $border-radius-md;
  background: $white;
  font-size: $sm-font;
  line-height: $md-font;

  &--full-height {
    height: 100%;
  }
}
</style>
